var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('slideshow'),_c('center_home'),_c('daielog',{attrs:{"open_accountlogin":_vm.open_accountlogins,"center":_vm.center},on:{"passfunction":_vm.passfunctions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }